import React from 'react';
import PropTypes from 'prop-types';

export const FxImageContainer = ({ children, containerHeading }) => (
  <div
    className="pad-responsive-extra stack"
    style={{
      maxWidth: '1440px',
      margin: 'auto',
      backgroundImage:
        "url('https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.24.1/package/dist/img/brand/worldservice-tile-brightblue.svg')",
    }}
  >
    <div className="dlsBlackBg">
      <div className="container">
        {containerHeading && (
          <h4 className="pad-b dls-white heading-5-g">{containerHeading}</h4>
        )}
        <div id="action-items" className="row">
          {children}
        </div>
      </div>
    </div>
  </div>
);

FxImageContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  containerHeading: PropTypes.string,
};
